<template>
    <div v-if="active" :style="height">
        <VueLoading :active.sync="activeSync"
                    :can-cancel="false"
                    :is-full-page="true"></VueLoading>
    </div>
</template>

<script>
    import VueLoading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
        name: 'Loading',
        props: {
            active: [Boolean, Number],
            fullPage: Boolean(true)
        },
        components: {
            VueLoading
        },
        computed: {
            height() {
                return this.fullPage ? { height: '100vh' } : {};
            },
            activeSync() {
                return Boolean(this.active)
            }
        }
    }
</script>